import { axiosInstance } from "../axios/axiosConfig";

const controller = "PaymentTransactions";

export const checkPaymentTransactionCompleted = async (orderNumber) => {
  try {
    const response = await axiosInstance.get(`${controller}/CheckPaymentTransactionCompleted/${orderNumber}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const hasPaymentTransactionStatusChanged = async (transactionId) => {
  try {
    const response = await axiosInstance.get(`${controller}/${transactionId}/HasPaymentTransactionStatusChanged`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const reverifyPaymentTransaction = async (queryString) => {
  try {
    const response = await axiosInstance.get(`${controller}/Reverify${queryString}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
